import addWatchedMarkup from './js/page-watched';
addWatchedMarkup();
import './js/queue-watched-modal';
import './js/lightSwitch';
import './js/btn-up';

